
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ActivityReportEstimatedEarningsResource,
  ActivityReportResource,
  ActivityReportSendingError,
  FillActivityReportRequest,
} from '../models';
import {
    ActivityReportEstimatedEarningsResourceFromJSON,
    ActivityReportEstimatedEarningsResourceToJSON,
    ActivityReportResourceFromJSON,
    ActivityReportResourceToJSON,
    ActivityReportSendingErrorFromJSON,
    ActivityReportSendingErrorToJSON,
    FillActivityReportRequestFromJSON,
    FillActivityReportRequestToJSON,
} from '../models';

export interface EvaluateEarningsForActivityReportRequest {
    activityReportId: string;
    totalWorkAmount?: number;
}

export interface FillDraftActivityReportRequest {
    activityReportId: string;
    fillActivityReportRequest: FillActivityReportRequest;
}

export interface GetActivityReportByIdRequest {
    activityReportId: string;
}

export interface GetActivityReportByProjectLotIdRequest {
    projectId: string;
    projectLotId: string;
}

export interface GetActivityReportsByProjectIdRequest {
    projectId: string;
}

export interface SendActivityReportToClientRequest {
    activityReportId: string;
    fillActivityReportRequest: FillActivityReportRequest;
}

export interface SendActivityReportToClientByAdminRequest {
    activityReportId: string;
    fillActivityReportRequest: FillActivityReportRequest;
}

/**
 * 
 */
export class ActivityTrackerApi extends runtime.BaseAPI {

    /**
     * Evaluate earnings based on declared activity report values or the one passed as a query parameter
          */
    async evaluateEarningsForActivityReportRaw(requestParameters: EvaluateEarningsForActivityReportRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityReportEstimatedEarningsResource>> {
        if (requestParameters['activityReportId'] == null) {
            throw new runtime.RequiredError(
                'activityReportId',
                'Required parameter "activityReportId" was null or undefined when calling evaluateEarningsForActivityReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['totalWorkAmount'] != null) {
            queryParameters['totalWorkAmount'] = requestParameters['totalWorkAmount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ActivityReportEstimatedEarningsResource>({
            path: `/project-freelancer/api/activity-tracker/activity-report/{activityReportId}/evaluateEarnings`.replace(`{${"activityReportId"}}`, encodeURIComponent(String(requestParameters['activityReportId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ActivityReportEstimatedEarningsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Evaluate earnings based on declared activity report values or the one passed as a query parameter
          */
    async evaluateEarningsForActivityReport(requestParameters: EvaluateEarningsForActivityReportRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityReportEstimatedEarningsResource> {
        const response = await this.evaluateEarningsForActivityReportRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Freelancer fills his activity report to input his work in draft mode
          */
    async fillDraftActivityReportRaw(requestParameters: FillDraftActivityReportRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityReportResource>> {
        if (requestParameters['activityReportId'] == null) {
            throw new runtime.RequiredError(
                'activityReportId',
                'Required parameter "activityReportId" was null or undefined when calling fillDraftActivityReport().'
            );
        }

        if (requestParameters['fillActivityReportRequest'] == null) {
            throw new runtime.RequiredError(
                'fillActivityReportRequest',
                'Required parameter "fillActivityReportRequest" was null or undefined when calling fillDraftActivityReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ActivityReportResource>({
            path: `/project-freelancer/api/activity-tracker/activity-report/{activityReportId}/draft`.replace(`{${"activityReportId"}}`, encodeURIComponent(String(requestParameters['activityReportId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FillActivityReportRequestToJSON(requestParameters['fillActivityReportRequest']),
        }, initOverrides);

        if (response._data) { response._data=ActivityReportResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Freelancer fills his activity report to input his work in draft mode
          */
    async fillDraftActivityReport(requestParameters: FillDraftActivityReportRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityReportResource> {
        const response = await this.fillDraftActivityReportRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch a single activity report by its id
          */
    async getActivityReportByIdRaw(requestParameters: GetActivityReportByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityReportResource>> {
        if (requestParameters['activityReportId'] == null) {
            throw new runtime.RequiredError(
                'activityReportId',
                'Required parameter "activityReportId" was null or undefined when calling getActivityReportById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ActivityReportResource>({
            path: `/project-freelancer/api/activity-tracker/activity-report/{activityReportId}`.replace(`{${"activityReportId"}}`, encodeURIComponent(String(requestParameters['activityReportId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ActivityReportResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch a single activity report by its id
          */
    async getActivityReportById(requestParameters: GetActivityReportByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityReportResource> {
        const response = await this.getActivityReportByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch an activity report by project lot id
          */
    async getActivityReportByProjectLotIdRaw(requestParameters: GetActivityReportByProjectLotIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityReportResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getActivityReportByProjectLotId().'
            );
        }

        if (requestParameters['projectLotId'] == null) {
            throw new runtime.RequiredError(
                'projectLotId',
                'Required parameter "projectLotId" was null or undefined when calling getActivityReportByProjectLotId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ActivityReportResource>({
            path: `/project-freelancer/api/activity-tracker/project/{projectId}/lot/{projectLotId}/activity-report`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"projectLotId"}}`, encodeURIComponent(String(requestParameters['projectLotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ActivityReportResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch an activity report by project lot id
          */
    async getActivityReportByProjectLotId(requestParameters: GetActivityReportByProjectLotIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityReportResource> {
        const response = await this.getActivityReportByProjectLotIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch all activity reports by project id
          */
    async getActivityReportsByProjectIdRaw(requestParameters: GetActivityReportsByProjectIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ActivityReportResource>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getActivityReportsByProjectId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ActivityReportResource>>({
            path: `/project-freelancer/api/activity-tracker/project/{projectId}/activity-reports`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ActivityReportResourceFromJSON);
        return response;
    }

    /**
     * Fetch all activity reports by project id
          */
    async getActivityReportsByProjectId(requestParameters: GetActivityReportsByProjectIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ActivityReportResource>> {
        const response = await this.getActivityReportsByProjectIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Freelancer updates his work amount and submits the activity report to the client
          */
    async sendActivityReportToClientRaw(requestParameters: SendActivityReportToClientRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityReportResource>> {
        if (requestParameters['activityReportId'] == null) {
            throw new runtime.RequiredError(
                'activityReportId',
                'Required parameter "activityReportId" was null or undefined when calling sendActivityReportToClient().'
            );
        }

        if (requestParameters['fillActivityReportRequest'] == null) {
            throw new runtime.RequiredError(
                'fillActivityReportRequest',
                'Required parameter "fillActivityReportRequest" was null or undefined when calling sendActivityReportToClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ActivityReportResource>({
            path: `/project-freelancer/api/activity-tracker/activity-report/{activityReportId}/submit`.replace(`{${"activityReportId"}}`, encodeURIComponent(String(requestParameters['activityReportId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FillActivityReportRequestToJSON(requestParameters['fillActivityReportRequest']),
        }, initOverrides);

        if (response._data) { response._data=ActivityReportResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Freelancer updates his work amount and submits the activity report to the client
          */
    async sendActivityReportToClient(requestParameters: SendActivityReportToClientRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityReportResource> {
        const response = await this.sendActivityReportToClientRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Admin updates freelancer work amount and submits the activity report to the client
          */
    async sendActivityReportToClientByAdminRaw(requestParameters: SendActivityReportToClientByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityReportResource>> {
        if (requestParameters['activityReportId'] == null) {
            throw new runtime.RequiredError(
                'activityReportId',
                'Required parameter "activityReportId" was null or undefined when calling sendActivityReportToClientByAdmin().'
            );
        }

        if (requestParameters['fillActivityReportRequest'] == null) {
            throw new runtime.RequiredError(
                'fillActivityReportRequest',
                'Required parameter "fillActivityReportRequest" was null or undefined when calling sendActivityReportToClientByAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ActivityReportResource>({
            path: `/project-freelancer/api/activity-tracker/activity-report/admin/{activityReportId}/submit`.replace(`{${"activityReportId"}}`, encodeURIComponent(String(requestParameters['activityReportId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FillActivityReportRequestToJSON(requestParameters['fillActivityReportRequest']),
        }, initOverrides);

        if (response._data) { response._data=ActivityReportResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Admin updates freelancer work amount and submits the activity report to the client
          */
    async sendActivityReportToClientByAdmin(requestParameters: SendActivityReportToClientByAdminRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityReportResource> {
        const response = await this.sendActivityReportToClientByAdminRaw(requestParameters, initOverrides);
        return response._data;
    }

}
